import axios from 'axios';
import { setupCache } from 'axios-cache-adapter'

// Create `axios-cache-adapter` instance
const cache = setupCache({
  maxAge: 15 * 60 * 1000
})


const token = localStorage.getItem('token');

const axiosinstance = axios.create({
  // adapter: cache.adapter,
  // baseURL: "http://localhost:8000/api/",
  // baseURL: "https://sandboxapi.mycopusa.com/api/",
  baseURL: "https://api.mycopusa.com/api/",
  // baseURL: 'https://fmsapi.yottaerp.com/api/',
  headers: {
    'Content-Type': 'application/json',
    'Authorization': token,
  }
});

export default axiosinstance;

// export const HeaderRequest = () => {
//   const token = localStorage.getItem('token');
//   return {headers : {Authorization : token}};
// }